import React from 'react'

import { TestimonialsSection } from 'components/testimonials-section/TestimonialsSection'

import type { SoundcoreTestimonialsCmsContent } from 'core/services/cms/interfaces'

import styles from './style.module.scss'


interface SoundcoreTestimonialsSectionProps {
  content: SoundcoreTestimonialsCmsContent
}

export const SoundcoreTestimonialsSection: React.FC<SoundcoreTestimonialsSectionProps> = ({ content }) => {
  return (
    <div className={styles.section}>
      <TestimonialsSection title={content.title} testimonials={content.items} />
    </div>
  )
}
